"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SEARCH_SESSION_ID = exports.AFFILIATE_PARAMS = void 0;
const AFFILIATE_PARAMS = exports.AFFILIATE_PARAMS = "affilParams";
const SEARCH_SESSION_ID = exports.SEARCH_SESSION_ID = "searchSessionId";

// TODO specific once everyone uses this